var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.638,
    height: 7.933,
    viewBox: "0 0 10.638 7.933",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-check",
    "data-name": "Icon awesome-check",
    d: "M3.613,12.354.156,8.9a.532.532,0,0,1,0-.752l.752-.752a.532.532,0,0,1,.752,0L3.989,9.721,8.977,4.733a.532.532,0,0,1,.752,0l.752.752a.532.532,0,0,1,0,.752L4.365,12.354A.532.532,0,0,1,3.613,12.354Z",
    transform: "translate(0 -4.577)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/done.d6d0758b7c8d51c55f29c60c7efee06d.svg";
export { ForwardRef as ReactComponent };